import { render, staticRenderFns } from "./addList.vue?vue&type=template&id=37b3ab4d&scoped=true"
import script from "./addList.vue?vue&type=script&lang=js"
export * from "./addList.vue?vue&type=script&lang=js"
import style0 from "./addList.vue?vue&type=style&index=0&id=37b3ab4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b3ab4d",
  null
  
)

export default component.exports